import Colors from '../../../global/colors';

import PictureRetina from '../picture-fill/picture-fill';

import classNames from 'classnames';
import flagStyles from '../styles/flag.module.scss';
import postStyles from '../../feed/posts/post.module.scss';
import styles from './users-modal.module.scss';
import ModalHeader from '../modal-portal-comp/components/modal-header/modal-header';
import ModalContainer from '../modal-portal-comp/components/modal-container/modal-container';

type Props = {
  users: Array<any>;
  onClose: any;
  getUserLink: any;
  firstUserLabel?: string;
  modalHeader: string;
};

const UsersModal = ({
  users,
  onClose,
  getUserLink,
  firstUserLabel,
  modalHeader,
}: Props) => {
  return (
    <ModalContainer height={'medium'} width={'skinny'}>
      <ModalHeader label={modalHeader} />
      <ul className={styles.items}>
        {users.map((user, index) => (
          <li
            className={classNames(
              `${flagStyles.flag} ${flagStyles['flag_custom-content']}`,
              styles.holder,
            )}
            key={index}
            onClick={onClose}
          >
            <a href={getUserLink(user['user_id'])} className={styles['link']}>
              <div
                className={`${flagStyles['flag__image']} ${flagStyles['flag__image_medium']}`}
              >
                <PictureRetina
                  class={postStyles['tile__avatar--small']}
                  imgStyle={
                    firstUserLabel && !index
                      ? {
                          borderRadius: '50%',
                          boxShadow: `0 0 0 2px white, 0 0 0 4px ${
                            Colors().primary600
                          }`,
                        }
                      : {}
                  }
                  url={user['image_profile'].url}
                  cloudinaryFilters='w_50,h_50,c_thumb,r_max'
                />
              </div>
              <div className={flagStyles['flag__body']}>
                {firstUserLabel && !index && (
                  <div className={styles['user-label']}>{firstUserLabel}</div>
                )}
                <h4 className={styles.user}>
                  {user['first_name']}&nbsp;{user['last_name']}
                </h4>
                <div className={styles['job-title']}>{user['job_title']}</div>
              </div>
            </a>
          </li>
        ))}
      </ul>
    </ModalContainer>
  );
};

UsersModal.displayName = 'UsersModal';
export default UsersModal;
